import React from "react";

const InfoWindow = (props) => {
    const { place } = props;

    return (
        <div
            style={{
                position: "relative",
                bottom: 100,
                left: "-45px",
                width: "max-content",
                backgroundColor: "white",
                boxShadow: "0 2px 7px 1px rgba(0, 0, 0, 0.3)",
                padding: 10,
                fontSize: 14,
                zIndex: 100,
            }}
        >
            <div style={{ fontSize: 16 }}>{place.institutionName}</div>
            <div>
                <div>{place.programDirector.address1}</div>
                <div>{place.programDirector.address2}</div>
                <div>{`${place.programDirector.city}, ${place.programDirector.state} ${place.programDirector.zip}`}</div>
            </div>
        </div>
    );
};

export default InfoWindow;
